import DefaultLayout from "../../layouts/default/DefaultLayout";
import {lazy} from "react";
import {ROUTE_PATH} from "../utils/constants";

const CompaniesManagement = lazy(() => import('../../components/companies-management/CompaniesManagement'));
const Licenses = lazy(() => import('../../components/licenses/Licenses'));
const UsersManagement = lazy(() => import('../../components/users-management/UsersManagement'));
const AuditLog = lazy(() => import('../../components/audit-log/AuditLog'));
const AlertsLog = lazy(() => import('../../components/alerts-log/AlertsLog'));

const routes = [
    {
        path: ROUTE_PATH.companiesManagement,
        component: CompaniesManagement,
        layout: DefaultLayout
    },
    {
        path: ROUTE_PATH.licenses,
        component: Licenses,
        layout: DefaultLayout
    },
    {
        path: ROUTE_PATH.usersManagement,
        component: UsersManagement,
        layout: DefaultLayout
    },
    {
        path: ROUTE_PATH.auditLog,
        component: AuditLog,
        layout: DefaultLayout
    },
    {
        path: ROUTE_PATH.alerts,
        component: AlertsLog,
        layout: DefaultLayout
    },
]

export default routes;
